module.exports = __webpack_public_path__ + "img/imprint-internal-scan.5bde48a7.png";